<template>
  <div class="bread-menu-wrap flex-space-between">
    <div class="bread-menu-wrap-left flex-center-align">
      当前位置:&nbsp;&nbsp;
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(level, index) in levelList" :key="index">
          <router-link :to="level.path">{{ level.label }}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bread-menu-wrap-right" v-if="levelList.length > 1">
      <span @click="goBack()">返回上级</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonBreadcrumb',
  data: function() {
    return {
      levelList: []
    };
  },
  watch: {
    $route(to) {
      this.levelList = [];
      to.matched.forEach((item) => {
        if (!item.meta) return;
        this.levelList.push({
          path: item.path,
          label: item.meta.label
        });
      });
    }
  },
  mounted() {
    this.levelList = [];
    this.$route.matched.forEach((item) => {
      if (!item.meta) return;
      this.levelList.push({
        path: item.path,
        label: item.meta.label
      });
    });
  },
  methods: {
    goBack() {
      const url = this.levelList[1].path;
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.bread-menu-wrap {
  line-height: 40px;
  font-size: 13px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #e5e5e5;
  .bread-menu-wrap-right {
    span {
      color: #145ccd;
      cursor: pointer;
    }
  }
}
</style>
